import { render, staticRenderFns } from "./TablePanel.vue?vue&type=template&id=67bdf003&scoped=true"
import script from "./TablePanel.vue?vue&type=script&lang=js"
export * from "./TablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bdf003",
  null
  
)

export default component.exports